// extracted by mini-css-extract-plugin
export var button = "_c6-0";
export var icon = "_c6-1";